import { GiWeightLiftingUp } from "react-icons/gi";
import { IoBarbellOutline, IoHomeOutline } from "react-icons/io5";

export function parseDate(date) {
  const dateObj = new Date(date);
  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
}

export const getEquipmentIcon = (name) => {
  switch (name) {
    case "Palestra":
      return <GiWeightLiftingUp className="me-1" style={{ marginBottom: 4 }} />;
    case "Casa":
      return <IoHomeOutline className="me-1" style={{ marginBottom: 4 }} />;
    case "Casa con manubri":
      return <IoBarbellOutline className="me-1" style={{ marginBottom: 4 }} />;
    default:
      return null;
  }
}